module.exports = __webpack_public_path__ + "static/GorditaLight-ffd7364f4c56750c19eeedac5167edc7.otf";